{
    "WebexAuth_UserIntro": "Olá **{}**,",
    "WebexAuth_UserIntro_2": "A CX Analytics está a solicitar o acesso ao seu tenant de Webex Calling.",
    "WebexAuth_AdminConsent": "Conceder consentimento de administração",
    "WebexAuth_Authorise": "Autorizar",
    "WebexAuth_ConsentedMessage": "Consentimento do administrador concedido. Clique em Autorizar para continuar.",
    "WebexAuth_AuthorisedMessage": "Autorização concedida",
    "WebexAuth_Decline": "Recusar",
    "WebexAuth_Error_Unknown": "Ocorreu um erro desconhecido. Por favor, tente novamente. Se o problema persistir, por favor, contacte o seu administrador do sistema.",
    "NAME": "WebexAuthLanguage"
}